import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteAccessConfigurationSurfaceProps = {
  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;
};

/**
 * A container element used to render the Project Access Configuration surface. This component will
 * take care of styling your component so it looks good in the **Project Configuration > Access & security** section in the Netlify UI.
 *
 * <!-- TODO(ndhoule): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteAccessConfiguration
 * @example
 * ```tsx
 * import { SiteAccessConfigurationSurface } from "@netlify/sdk/react/components";
 *
 * <SiteAccessConfigurationSurface>
 *   <div>Your surface content goes here</div>
 * </SiteAccessConfigurationSurface>
 * ```
 */
export const SiteAccessConfigurationSurface = ({
  className,
  children,
  ...otherProps
}: SiteAccessConfigurationSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteAccessConfiguration}-${sdk.extension.slug}`}
      className={className}
      {...otherProps}
    >
      {children}
    </section>
  );
};
